import { InjectionToken, Provider } from '@angular/core'

export const logoAssetsToken = new InjectionToken<LogoAssets>('LogoAssetsToken')

export interface LogoAssets {
  readonly altImg: string
  readonly imgSrc: string
}

const logoAssets: LogoAssets = {
  altImg: $localize`:Logo alt img home:Game sans logo`,
  imgSrc: 'assets/sans-logomark.png',
}

export const logoAssetsProvider: Provider = [
  {
    provide: logoAssetsToken,
    useValue: logoAssets,
  },
]
